// extracted by mini-css-extract-plugin
module.exports = {"image":"Decision_image__1WEx5"};